import React from 'react';
import { ItinerairePoint } from '../types/Commune';
import './ItineraireList.css';

interface ItineraireListProps {
  itineraire: ItinerairePoint[];
}

const ItineraireList: React.FC<ItineraireListProps> = ({ itineraire }) => {
  const totalDistance = itineraire.reduce((sum, point) => sum + point.distance, 0);

  if (itineraire.length === 0) {
    return (
      <div className="itineraire-list">
        <h3>Liste de l'itinéraire</h3>
        <p>Aucun itinéraire calculé</p>
      </div>
    );
  }

  return (
    <div className="itineraire-list">
      <h3>Liste de l'itinéraire</h3>
      
      <div className="itinerary-summary">
        <div className="summary-item">
          <span className="summary-label">Nombre d'étapes:</span>
          <span className="summary-value">{itineraire.length}</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">Distance totale:</span>
          <span className="summary-value">{totalDistance.toFixed(1)} km</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">Commune de départ:</span>
          <span className="summary-value">{itineraire[0]?.commune.nom}</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">Commune d'arrivée:</span>
          <span className="summary-value">{itineraire[itineraire.length - 1]?.commune.nom}</span>
        </div>
      </div>

      <div className="itinerary-steps">
        <h4>Détail des étapes</h4>
        <div className="steps-container">
          {itineraire.map((point, index) => {
            const isStart = index === 0;
            const isEnd = index === itineraire.length - 1;
            
            return (
              <div key={point.commune.id} className={`step-item ${isStart ? 'start' : ''} ${isEnd ? 'end' : ''}`}>
                <div className="step-number">
                  {isStart ? 'D' : isEnd ? 'A' : index + 1}
                </div>
                <div className="step-content">
                  <div className="step-header">
                    <h5>{point.commune.nom}</h5>
                    <span className="step-id">ID: {point.commune.id}</span>
                  </div>
                  <div className="step-details">
                    <p><strong>Ville :</strong> {point.commune.ville} ({point.commune.codePostal})</p>
                    <p><strong>Population :</strong> {point.commune.nombreHabitants.toLocaleString()} habitants</p>
                    <p><strong>Département :</strong> {point.commune.departement}</p>
                    <p><strong>Statut :</strong> {point.commune.statut}</p>
                    {point.commune.latitude && point.commune.longitude && (
                      <p><strong>Coordonnées :</strong> {point.commune.latitude.toFixed(4)}, {point.commune.longitude.toFixed(4)}</p>
                    )}
                    {point.distance > 0 && (
                      <p className="step-distance">
                        Distance depuis l'étape précédente: {point.distance.toFixed(1)} km
                      </p>
                    )}
                    {point.commune.telephone && (
                      <p><strong>Téléphone :</strong> {point.commune.telephone}</p>
                    )}
                    {point.commune.email && (
                      <p><strong>Email :</strong> {point.commune.email}</p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="itinerary-notes">
        <h4>Notes</h4>
        <ul>
          <li>L'itinéraire utilise l'algorithme du plus proche voisin pour optimiser le trajet</li>
          <li>Le rayon de recherche est de 50km autour de la commune sélectionnée</li>
          <li>Les distances sont calculées en ligne droite (à vol d'oiseau)</li>
          <li>Les coordonnées sont estimées à partir des codes postaux</li>
          <li>Pour un itinéraire routier précis, utilisez un GPS ou une application de navigation</li>
        </ul>
      </div>
    </div>
  );
};

export default ItineraireList; 